<template>
  <basic-container>
    <el-form
      :model="searchForm"
      ref="searchFormRef"
      label-suffix=":"
      label-width="80px"
      v-show="searchBoxFlag"
    >
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="项目名称" prop="projectId">
            <el-select
              v-model="searchForm.projectId"
              style="width:100%"
              placeholder="请选择"
              @change="projectIdChange"
            >
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="18">
                <div style="float:right">
                              <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small"> 搜索 </el-button>
                              <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
                </div>
            </el-col>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="addRecord">
          新 增</el-button
        >
      </template>
      <template slot="menuRight">
        <searchFromShow
          :searchBoxFlag.sync="searchBoxFlag"
          :removeHeight="searchHeight"
          :option="option"
          :refOption="$refs.crud"
        ></searchFromShow>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button

          type="text"
          size="small"
          icon="el-icon-edit"
          @click="editRecord(scope.row)"
          >编辑
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-delete"

          @click="removeRecord(scope.row.id)"
          >删除
        </el-button>
      </template>
    </avue-crud>
    <hr-dialog :title="recordTittle" :allowFull="false" width="60%" :visible.sync="visible">
      <template slot="body">
        <Record @cancle="recordCancle" v-if="visible" :row="row" @success="recordSuccess"></Record>
      </template>
    </hr-dialog>
  </basic-container>
</template>

<script>
import { getProjectList } from '@/api/crmedical/project/project';
import searchFromShow from '@/components/search-form-show/index';
import { getPageList, save, remove, update } from '@/api/crmedical/contract/contractSetting/contractSetting';
import Record from './record.vue';
export default {
  components: { searchFromShow, Record },
  data() {
    return {
        recordTittle:'新增成员权限',
        visible:false,
      searchForm: {
        projectId: '',
      },
      projectList: [],
      data: [],
      option: {
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '项目名称',
            prop: 'projectName',
          },
           {
            label: '合同类型',
            prop: 'typeName',

          },
          {
            label: '权限成员',
            prop: 'userNames',
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      searchBoxFlag: true,
      searchHeight: '',
       row:{
           projectId:'',
           type:'',
           userIdList:[]
       },

      receivePeopleOption: {
        projectId: '',
        variable: '',
        searchType: '',
        deptId: '',
        model: 'unlimitPeople', //singlePeople(单选人员)，people(选人 有限制加limit) unlimitPeople(无限制选人) dept(部门 有限制加上limit) singleDept unlimitDept(无限制选部门)
        selectList: [], //已选的集合
        prohibitList: [], //禁止选的集合
        limit: 20,
      },

    };
  },
  created() {
    this.initData();
  },
  computed: {},
  mounted() {
    this.calcHeight();
  },
  methods: {
    recordCancle(){
      this.visible=false
    },
    recordSuccess(){
      this.visible=false
      this.page.currentPage =1
      this.onLoad()
    },
    searchRecord(){
      this.onLoad()
    },
    searchClear(){
      this.page.currentPage =1
    },
      removeRecord(id){
            this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove(id);
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
      },
      editRecord(row){
          this.row = Object.assign({},row)
          this.recordTittle = '修改合同权限'
          this.visible = true

      },
      addRecord(){
          this.tool.clearObject(this.row)
          this.recordTittle="新增合同权限"
          this.row.projectId = this.searchForm.projectId
          this.visible = true
      },
    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 279;
    },
    async initData() {
      await getProjectList().then((res) => {
        this.projectList = res.data;
        if (this.projectList.length > 0) {
          this.$set(this.searchForm, 'projectId', this.projectList[0].id);

          //   this.form.projectId = this.projectList[0].id;
        }
      });
      this.onLoad(this.searchForm.projectId);
    },
    onLoad() {
      this.loading = true;
      if (this.searchForm.projectId) {
        getPageList(
          Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            this.searchForm
          )
        )
          .then(({ data }) => {
            this.data = data.records;
            this.page.total = data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
::v-deep .avue-crud__right {
  display: flex;
}
</style>
